import { render } from "./IdentificationWaiting.vue?vue&type=template&id=5e050159&ts=true"
import script from "./IdentificationWaiting.vue?vue&type=script&lang=ts"
export * from "./IdentificationWaiting.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__